import { CommonUtil } from '@utils/common/common';
import { uniqBy, maxBy } from 'lodash';
import moment from 'moment';
export class RankingChartOption {
  categoryRankings(data: any, selectedProperties: string[] | null) {
    const _data = CommonUtil.getArrayByValidate(data);

    let seriesData = []; // 하이차트 시리즈데이터
    let maxRanking = 0;

    if (_data.length > 0) {
      // 고유속성명
      let uniqueProperty = Array.from(new Set(_data.map((x) => x.property)));
      // seriesNames
      let seriesNames = uniqBy(
        _data.map((x) => ({ unique: `${x.gameName}_${x.property}`, gameName: x.gameName, property: x.property })),
        'unique'
      );

      if (!!selectedProperties && selectedProperties.length > 0) {
        seriesNames = seriesNames.filter((x) => selectedProperties.includes(x.property));
        uniqueProperty = selectedProperties;
      }

      maxRanking = maxBy(_data, 'value').value;

      seriesNames.forEach((seriesName) => {
        seriesData.push({
          name: `${seriesName.gameName}_${seriesName.property}`,
          data: _data
            .filter((x) => x.gameName === seriesName.gameName && x.property === seriesName.property)
            .map((x) => {
              return { name: x.baseDate, y: x.value, property: x.property };
            }),
        });
      });
    }

    return {
      series: seriesData,
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: { text: '' },
        labels: {
          overflow: 'justify',
          style: {
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: '11px',
          },
          formatter: function () {
            if (moment(this.value, 'YYYY-MM-DD', true).isValid()) {
              return moment(this.value, 'YYYY-MM-DD').format('MM/DD');
            } else {
              return this.value;
            }
          },
        },
      },
      yAxis: {
        title: {
          text: 'Ranking',
        },
        reversed: true,
        min: 0,
        max: maxRanking,
      },
    };
  }
}
